/**
 * This module is used to language translations.
 * The translations are saved in a json file in /src/app/assets/i18n directory
 * Docs: https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-angular7-app-with-ngx-translate
 */
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
// import ngx-translate and the http loader
import {
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
    TranslateLoader,
    TranslateModule,
    TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

// ngx-translate - required for AOT compilation
export function createTranslateLoader(http: HttpClient) {
    if (window.location.hostname === 'localhost') {
        return new TranslateHttpLoader(
            http,
            '/assets/' + environment.modul + '/i18n/' + environment.modul + '-',
            '.json',
        );
    }
    let url =
        !window.location.hostname.includes('staging') &&
        !window.location.hostname.includes('development')
            ? environment.bildverifizierungUrl.replace('-staging', '')
            : environment.bildverifizierungUrl;

    return new TranslateHttpLoader(
        http,
        url +
            '/assets/' +
            environment.modul +
            '/i18n/' +
            environment.modul +
            '-',
        '.json',
    );
}
export class MyMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        return params.key;
    }
}

@NgModule({
    declarations: [],
    imports: [
        HttpClientModule,
        TranslateModule.forRoot({
            defaultLanguage: 'de',
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MyMissingTranslationHandler,
            },
        }),
    ],
    exports: [TranslateModule],
})
export class LanguageTranslationModule {
    constructor(private translate: TranslateService) {
        // Gets Default language from browser if available, otherwise set English ad default
        this.translate.addLangs([
            'en',
            'fr',
            'ur',
            'es',
            'it',
            'fa',
            'de',
            'zh-CHS',
        ]);
        let language =
            localStorage.getItem('Language') || this.translate.getBrowserLang();
        this.translate.use(
            language?.match(/en|fr|ur|es|it|fa|de|zh-CHS/) ? language : 'en',
        );
    }
}
